const nameCls = "_275n1fl4zz7";
const logoutCls = "_275l18ss9f0";

export { logoutCls, nameCls };
import "./atom.user.style.linaria.module.css";
//# sourceMappingURL=atom.user.style.js.map
